if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
          // Focus next visible input
          const closestContainer = this.closest('.parent-display, .mobile-facets__submenu');
          if (closestContainer) {
            const nextElementToFocus = Array.from(closestContainer.querySelectorAll('.show-more-item')).find(item => 
              !item.classList.contains('hidden') && item.querySelector('input')
            );
            if (nextElementToFocus && nextElementToFocus.querySelector('input')) {
              nextElementToFocus.querySelector('input').focus();
            }
          }
        });
      }
      expandShowMore(event) {
        // Will work for both desktop and mobile containers
        const parentDisplay = this.closest('.parent-display, .mobile-facets__submenu');
        if (!parentDisplay) return;

        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}